import React, { memo, useContext, useMemo } from 'react';
import cx from 'classnames';

import { PreviewComponentProps } from '../../EmailTemplatePreview';
import EditorContext, { EditorContextProps } from '../../../Editor/Context';
import Cta from '../Components/Cta';
import ChatBubble from '../Components/ChatBubble';
import VideoPreview from '../Components/VideoPreview';
import Sender from '../Components/Sender';
import { getTimestamp } from '~/utils/date';
import Disclaimer from '../Components/Disclaimer';
import Footer from '../Components/Footer';
import Logo from '../Shared/Logo';
import Banner from '../Components/Banner';
import { useVmPlan } from '~/react-hooks/use-plans';

const Html4 = memo(
  ({
    image,
    name,
    bio,
    logoUrl,
    playerImage,
    theme,
    children,
    hidePreviewTag,
    bannerContent,
    disclaimerContent,
  }: PreviewComponentProps) => {
    const editorContext: EditorContextProps = useContext(EditorContext);
    const { isFreePlan } = useVmPlan();
    const { preview } = editorContext;

    const isMobile = useMemo(() => {
      return preview === 'mobile';
    }, [preview]);

    return (
      <div
        className={cx('rounded-md border border-solid', {
          'border-white': isMobile,
          'border-neutral-300 mx-14': !isMobile,
        })}
      >
        {name && (
          <Banner sender={name} className='mb-8' content={bannerContent} />
        )}
        <div className={`m-auto w-[${isMobile ? '250px' : '350px'}]`}>
          <Sender
            image={image}
            name={name}
            bio={bio}
            subtitle={`Recorded on ${getTimestamp()} UTC`}
            className='pb-5'
            senderClassName='!font-bold text-neutral-900'
            bioClassName='!font-bold text-neutral-900'
          />
          <ChatBubble
            className='pb-5'
            chatBubbleClassName='px-4 pt-3 pb-1 text-black'
            showArrow
          >
            {children}
          </ChatBubble>
          {logoUrl && <Logo logoUrl={logoUrl} className='pt-0 h-20' />}
          <VideoPreview
            thumbnail={playerImage}
            hidePreviewTag={hidePreviewTag}
          />
          <Cta
            textColor={theme?.secondaryColor}
            bgColor={theme?.primaryColor}
            className='pt-5'
          />
        </div>
        <Disclaimer className='py-6 text-black' contents={disclaimerContent} />
        {isFreePlan && <Footer />}
      </div>
    );
  }
);

export default Html4;
